'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetching = exports.hasOutstandingMTA = exports.createPolicySlice = undefined;
var _redux = require('redux');
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _constants = require('./constants');
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var hasProp = Object.prototype.hasOwnProperty;
var createPolicySlice = exports.createPolicySlice = function createPolicySlice(name) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var action = arguments[1];
    switch (action.type) {
      case _constants.actionTypes.FETCH_CUSTOMER + '_' + _reduxPromiseMiddleware.FULFILLED:
        if (hasProp.call(action.payload.data.data, name)) {
          return action.payload.data.data[name];
        }
        return [];
      default:
        return state;
    }
  };
};
var hasOutstandingMTA = exports.hasOutstandingMTA = function hasOutstandingMTA() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.FETCH_CUSTOMER + '_' + _reduxPromiseMiddleware.PENDING:
      return true;
    case _constants.actionTypes.FETCH_CUSTOMER + '_' + _reduxPromiseMiddleware.FULFILLED:
      return action.payload.data.data.hasOutstandingMTA;
    case _constants.actionTypes.FETCH_CUSTOMER + '_' + _reduxPromiseMiddleware.REJECTED:
    default:
      return state;
  }
};
var fetching = exports.fetching = function fetching() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.FETCH_CUSTOMER + '_' + _reduxPromiseMiddleware.PENDING:
      return true;
    case _constants.actionTypes.FETCH_CUSTOMER + '_' + _reduxPromiseMiddleware.FULFILLED:
    case _constants.actionTypes.FETCH_CUSTOMER + '_' + _reduxPromiseMiddleware.REJECTED:
      return false;
    default:
      return state;
  }
};
var policies = _constants.policyTypes.reduce(function (acc, curr) {
  return Object.assign({}, acc, _defineProperty({}, curr, createPolicySlice(curr)));
}, {});
var contactPrefs = function contactPrefs() {
  var _fetching;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fetching: (_fetching = {}, _defineProperty(_fetching, _constants.contactPrefsFormIds.contact, false), _defineProperty(_fetching, _constants.contactPrefsFormIds.interests, false), _fetching)
  };
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.FETCH_CUSTOMER_PREFS + '_' + _reduxPromiseMiddleware.PENDING:
      return Object.assign({}, state, {
        fetching: Object.assign({}, state.fetching, _defineProperty({}, action.meta.formId, true))
      });
    case _constants.actionTypes.FETCH_CUSTOMER_PREFS + '_' + _reduxPromiseMiddleware.FULFILLED:
      return Object.assign({}, state, {
        fetching: Object.assign({}, state.fetching, _defineProperty({}, action.meta.formId, false))
      });
    default:
      return state;
  }
};
exports.default = (0, _redux.combineReducers)(Object.assign({}, policies, {
  hasOutstandingMTA: hasOutstandingMTA,
  fetching: fetching,
  contactPrefs: contactPrefs
}));